import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import RequireUser from "@/components/public/RequireUser";
import TournamentManager from "@/components/tournament/TournamentManager";

export default function ManageTournament() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <RequireUser message="Sign in to manage your tournament.">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-8">
        <Link to="/profile" className="eyebrow text-white/50 hover:text-white inline-flex items-center gap-1.5 mb-5" data-testid="back-to-profile"><ArrowLeft size={13} /> My Profile</Link>
        <TournamentManager id={id} onDeleted={() => navigate("/profile")} />
      </div>
    </RequireUser>
  );
}
